"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Version$ = exports.Version$outboundSchema = exports.Version$inboundSchema = void 0;
exports.versionToJSON = versionToJSON;
exports.versionFromJSON = versionFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const semversion_js_1 = require("./semversion.js");
/** @internal */
exports.Version$inboundSchema = z.object({
    message: z.string(),
    version: semversion_js_1.SemVersion$inboundSchema,
    version_str: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "version_str": "versionStr",
    });
});
/** @internal */
exports.Version$outboundSchema = z.object({
    message: z.string(),
    version: semversion_js_1.SemVersion$outboundSchema,
    versionStr: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        versionStr: "version_str",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Version$;
(function (Version$) {
    /** @deprecated use `Version$inboundSchema` instead. */
    Version$.inboundSchema = exports.Version$inboundSchema;
    /** @deprecated use `Version$outboundSchema` instead. */
    Version$.outboundSchema = exports.Version$outboundSchema;
})(Version$ || (exports.Version$ = Version$ = {}));
function versionToJSON(version) {
    return JSON.stringify(exports.Version$outboundSchema.parse(version));
}
function versionFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Version$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Version' from JSON`);
}
//# sourceMappingURL=version.js.map